import React, { useEffect } from "react";
import {
  CCol,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CButton,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { useState } from "react";
import { loadingState } from "src/atom/LoadingState";
import { useRecoilState } from "recoil";
import { useNavigate } from "react-router-dom";
import "reactjs-popup/dist/index.css";
import {
  createTicketTemplate,
  getTicketTemplate,
  deleteTicketsTemplate,
} from "src/services/Tickets/StudentTicketService";
import Confirmation from "src/components/Confirmation";
import Pagination from "src/components/Paginator";
import { alertMessageState } from "src/atom/LoadingState";

const TicketReply = () => {
  const courseObj = {
    name: "",
    content: "",
  };
  const [visible, setVisible] = useState(false);
  const [formData, setFormData] = useState(courseObj);
  const [validationErrors, setValidationErrors] = useState({
    name: "",
    content: "",
  });
  const [, enableLoader] = useRecoilState(loadingState);
  const [, setIsSubmitted] = useState(false);
  const [, setLoading] = useState(false);
  const [ticketReply, setTicketReply] = useState([]);
  const [ticketId, setTicketId] = useState(null);
  const [warningMessage, setWarningMessage] = useState("");
  const [, setAlertMessage] = useRecoilState(alertMessageState);

  const validateForm = () => {
    let errors = {};
    let isValid = true;
    if (!formData.name) {
      errors.name = "Please Provide Ticket Template.";
      isValid = false;
    }
    if (!formData.content) {
      errors.content = "Please Provide Content.";
      isValid = false;
    }
    setValidationErrors(errors);
    return isValid;
  };

  const getAllTicketTemplates = async () => {
    enableLoader(true);
    var getTicketTemplates = async () => {
      enableLoader(false);
      var response = await getTicketTemplate({
        pageNumber: pagination.currentPage,
        search: pagination.search,
        pageSize: pagination.size,
      });
      if (response.success) {
        setTicketReply(response.body.templates);
        setPagination((prevValue) => ({
          ...prevValue,
          totalItems: response.body.totalElements,
          totalPages: Math.ceil(response.body.totalElements / pagination.size),
        }));
        enableLoader(false);
      } else {
        enableLoader(false);
        setAlertMessage(response.message);
      }
    };
    getTicketTemplates();
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const regex = /^[a-zA-Z0-9\s]*$/;

    if (regex.test(value) || value === "") {
      setFormData((prevValues) => ({
        ...prevValues,
        [name]: value,
      }));
    }
  };

  const handleDelete = (id) => {
    setTicketId(id);
    setWarningMessage("Are you sure you want to delete this Template?");
  };

  const deleteTicketTemplate = async () => {
    enableLoader(true);
    var deleteTickets = async () => {
      var response = await deleteTicketsTemplate(ticketId);
      if (response.success) {
        getAllTicketTemplates();
        enableLoader(false);
        setTicketId(null);
      } else {
        enableLoader(false);
        setAlertMessage(response.message);
      }
    };
    deleteTickets();
  };
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/adminHelpDesk");
  };

  const mapToCollegeObj = (tickets) => {
    return {
      id: tickets.id,
      name: tickets.name,
      content: tickets.content,
    };
  };

  const [pagination, setPagination] = useState({
    currentPage: 1,
    perPage: 10,
    totalItems: 0,
    totalPages: 0,
    next: "",
    prev: "",
    size: 10,
    search: "",
  });

  const nextPage = (event) => {
    setPagination((prevValue) => ({
      ...prevValue,
      currentPage: event,
    }));
  };

  useEffect(() => {
    getAllTicketTemplates();
  }, [pagination.currentPage, pagination.size]);

  const handleSubmit = async (e) => {
    enableLoader(true);
    e.preventDefault();
    setIsSubmitted(true);
    const isValid = validateForm();
    if (isValid) {
      setValidationErrors({});
      setLoading(true);
      const response = await createTicketTemplate(formData);
      if (response.success) {
        setFormData({});
        getAllTicketTemplates();
        setVisible(false);
      } else {
        setAlertMessage(response.message);
      }
      setLoading(false);
    }
  };

  return (
    <>
      <div className="card">
        <div
          className="card-header text-white"
          style={{ backgroundColor: "#3C4B64" }}
        >
          <div className="d-flex align-items-center justify-content-between">
            <span className="mr-auto"> Templates</span>
            <div className="d-flex justify-content-end">
              <CButton
                style={{ marginRight: "10px" }}
                onClick={() => {
                  handleButtonClick();
                }}
              >
                Back
              </CButton>
              <CButton
                style={{ marginRight: "10px" }}
                onClick={() => {
                  setVisible(!visible);
                  setFormData(courseObj);
                }}
              >
                + Add Template
              </CButton>
            </div>
          </div>
        </div>
        <div className="card-body">
          <CCol xs={12}>
            <CTable striped bordered responsive>
              <CTableHead>
                <CTableRow>
                  <CTableHeaderCell scope="col">S.No</CTableHeaderCell>
                  <CTableHeaderCell scope="col">Name</CTableHeaderCell>
                  <CTableHeaderCell scope="col">Content</CTableHeaderCell>
                  <CTableHeaderCell scope="col" style={{ width: "11%" }}>
                    Action
                  </CTableHeaderCell>
                </CTableRow>
              </CTableHead>
              <CTableBody>
                {ticketReply?.length !== 0 ? (
                  ticketReply?.map((tickets, index) => {
                    return (
                      <CTableRow key={index}>
                        <CTableHeaderCell scope="row">
                          {index + 1}
                        </CTableHeaderCell>
                        <CTableDataCell>{tickets.name}</CTableDataCell>
                        <CTableDataCell>{tickets.content}</CTableDataCell>
                        <CTableDataCell>
                          <div className="d-flex flex-wrap">
                            <button
                              className="btn btn-info btn-sm mb-2 me-2"
                              onClick={() => {
                                setVisible(!visible);
                                setFormData(mapToCollegeObj(tickets));
                              }}
                            >
                              Edit
                            </button>
                            <button
                              className="btn btn-primary btn-sm mb-2"
                              onClick={() => handleDelete(tickets.id)}
                            >
                              Delete
                            </button>
                          </div>
                        </CTableDataCell>
                      </CTableRow>
                    );
                  })
                ) : (
                  <CTableRow>
                    <CTableDataCell colSpan={4}>
                      No templates found.
                    </CTableDataCell>
                  </CTableRow>
                )}
              </CTableBody>
            </CTable>
          </CCol>
          <div className="row">
            <div className="col-12 d-flex justify-content-center">
              <Pagination
                pagination={pagination}
                range={3}
                nextPage={nextPage}
                setPagination={setPagination}
              />
            </div>
          </div>
        </div>
      </div>
      <CModal
        scrollable
        visible={visible}
        onClose={() => setVisible(false)}
        size="lg"
      >
        <CModalHeader>
          <CModalTitle>Add Ticket Template</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <div className="container mt-4">
            <form onSubmit={handleSubmit}>
              <div className="row mb-2">
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="name">Name</label>
                    <input
                      type="text"
                      className={`form-control ${
                        validationErrors.name ? "is-invalid" : ""
                      }`}
                      id="name"
                      placeholder="Enter ticket template"
                      name="name"
                      value={formData?.name}
                      onChange={handleInputChange}
                      maxLength={50}
                    />
                    {validationErrors.name && (
                      <div className="invalid-feedback">
                        {validationErrors.name}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group">
                    <label htmlFor="name">Content</label>
                    <textarea
                      className={`form-control ${
                        validationErrors.content ? "is-invalid" : ""
                      }`}
                      placeholder="Enter content"
                      id="content"
                      name="content"
                      value={formData?.content}
                      onChange={handleInputChange}
                      rows="3"
                      maxLength={500}
                    />
                    {validationErrors.content && (
                      <div className="invalid-feedback">
                        {validationErrors.content}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="mt-5 text-center">
                <button type="submit" className="btn btn-success text-white">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </CModalBody>
      </CModal>
      <Confirmation
        onCancel={() => {
          setWarningMessage("");
        }}
        onContinue={() => {
          deleteTicketTemplate();
          setWarningMessage("");
        }}
        warning={warningMessage}
      />
    </>
  );
};

export default TicketReply;
